<template>
    <div>
       <div v-show="inited"> <search></search></div>
    </div>
</template>

<script>

import { AZEventBus } from '../components/AZEventBus.js';
import Search from '../components/Search';
export default {
    components: {Search},
    data: function(){
        return {
            a: 'nada',
            inited: false,
            theUrl: ''
        }
    },
    mounted: function(){    
        var self = this   

        document.getElementById('nav').style.display = 'none'

        function init(){
             if (self.$route.query.s){
                 self.$root.app.doShowModal('editModal', {url: self.sanitizeURL(self.$route.query.s)})
                 self.theUrl = self.$route.query.s
                 self.inited = true
             }
                
        }

        if(self.$root.app.doneFederating){
            self.inited = true
            init();
        }

        AZEventBus.$once('onFederate', msg => {
          if(self.inited == false)
            init();
        });
    },

    methods: {
         sanitizeURL: function(url){
            var newURL = url.split('://');

            if (newURL.length == 1){
                return  'http://' + url
            }

            return url
        },

        doItAgain: function(){
           
            if(this.theUrl)
                this.$root.app.doShowModal('editModal', {url: this.sanitizeURL(this.theUrl)})
        }
    }
}
</script>